import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface ImportSettingsDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ImportSettingsDialog: React.FC<ImportSettingsDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="import-settings-dialog-title"
      aria-describedby="import-settings-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle 
        id="import-settings-dialog-title"
        sx={{ pb: 1 }}
      >
        Import Project Settings
      </DialogTitle>
      <DialogContent sx={{ pt: 1, pb: 2 }}>
        <DialogContentText 
          id="import-settings-dialog-description"
          sx={{ mb: 0 }}
        >
          Are you sure you want to import these project settings? This will overwrite your current settings.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pt: 0, pb: 2, px: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} autoFocus variant="contained">
          Import
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportSettingsDialog;
